<template>
  <modal
    name="upgrade-successful"
    :click-to-close="false"
    height="auto"
    :adaptive="true"
    :scrollable="true"
    width="75%"
    :max-width="900"
    :pivot-y="0.2"
  >
    <Button class="close-button" @click="closeModal">
      <v-icon slot="icon-end" name="times" />
    </Button>

    <div class="text-center">
      <div class="content">
        <h1 class="text-center text-lg sm:text-2xl mb-6 md:mb-8 lg:mb-12">
          🎉 &nbsp;Upgrade Successful &nbsp;🎉
        </h1>

        <img
          src="https://media.giphy.com/media/hZj44bR9FVI3K/giphy.gif"
          alt="Seinfeld celebrating gif"
          class="rounded-lg mb-6 lg:mb-10 shadow-lg"
        />

        <div class="max-w-sm mx-auto">
          <p class="mb-4 font-lato text-support text-lg">
            Thanks for upgrading and welcome to Promo 💌
          </p>

          <p class="mb-3 text-support-light text-sm">
            If you have any questions, get stuck or just want to say hello
            please don't hesitate to get in touch with our friendly support
            team.
          </p>

          <p class="mb-2 text-support-light text-sm font-lato">
            Let's get started!!
          </p>

          <p class="mb-4 text-support-light text-sm">
            What do you want to do with this newsletter&hellip;
          </p>

          <div class="flex justify-center">
            <Button class="secondary sm mr-1" @click="onDownloadClick">
              <v-icon
                slot="icon-start"
                name="download"
                scale="0.9"
                class="mr-1"
              />Download
            </Button>

            <Button class="primary sm ml-1" @click="onApproveClick">
              <v-icon
                slot="icon-start"
                name="paper-plane"
                scale="0.9"
                class="mr-1"
              />Approve to Send
            </Button>
          </div>
          <!-- .flex -->

          <p class="text-xs text-support mb-0">
            &hellip;or
            <Button class="link edit-newsletter-button" @click="closeModal">
              edit it
            </Button>
            first.
          </p>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import EventBus from "@/lib/event-bus.js";

export default {
  name: "UpgradeSuccessfulModal",

  methods: {
    closeModal() {
      this.$modal.hide("upgrade-successful");
      // Remove the upgrade successful key from the query string so the user doesn't see it again upon refresh
      this.$router.replace(`/campaign/${this.$route.params.id}`);
    },
    onApproveClick() {
      EventBus.$emit("approve-send");
      this.closeModal();
    },
    onDownloadClick() {
      this.closeModal();

      this.$modal.show("download-campaign", {
        campaignId: this.$route.params.id,
      });
    },
  },
};
</script>

<style scoped>
>>> .v--modal {
  padding: 0;
}

.content {
  @apply py-6 px-4;

  @screen md {
    @apply p-8;
  }

  @screen lg {
    @apply py-12;
  }
}

.action-panel {
  @apply flex flex-wrap w-full border-grey-lighter border-t bg-grey-lightest p-4 relative;

  button {
    @apply p-1;
  }

  @screen md {
    @apply p-8;

    button {
      @apply py-2 px-4;
    }
  }
}

.edit-newsletter-button {
  @apply text-xs text-support px-0 underline inline-block;

  &:hover {
    @apply no-underline;
  }
}
</style>
